import * as React from 'react';
import { ButtonProps } from '@mui/material';

import { SubmitButton as SubmitButtonCore } from '@homesusa/core';
import { useCatchHttpError } from '../hooks';

export function SubmitButton({
  onClick,
  ...props
}: {
  onClick: () => Promise<void>;
  buttonProps?: ButtonProps;
  children: React.ReactNode;
  tooltipTitle?: React.ReactNode;
}): JSX.Element {
  const catchError = useCatchHttpError();
  return (
    <SubmitButtonCore {...props} onClick={async (): Promise<void> => onClick().catch(catchError)} />
  );
}
